import httpClient from './httpClient'
import store from '../store'

export default {
  async updateLiveTitle(live_id, title) {
    let ret = await httpClient.put('/lives/' + live_id, {
      title: title,
    })
    return ret
  },
  async initLive(live_id) {
    let ret = await httpClient.post(`/lives/${live_id}/start`)
    return ret
  },
  async endLive(live_id) {
    let ret = await httpClient.post(`/lives/${live_id}/finish`)
    return ret
  },
  async createLiveSchedule(title, date) {
    const session = await store().dispatch('session/refreshSession')
    let ret = await httpClient.post('/lives', {
      title: title,
      scheduled_at: date,
      refresh_token: session.refreshToken.token,
    })
    return ret
  },
  async getLive(live_id) {
    let ret = await httpClient.get('/lives/' + live_id)
    return ret
  },
  async getViewers(live_id) {
    let ret = await httpClient.get(`/analytics/live/${live_id}/viewers`)
    return ret
  },
  async getViewersHistoric(live_id) {
    let ret = await httpClient.get(`/analytics/live/${live_id}/viewers_historic`)
    return ret
  },
  async getLives() {
    let ret = await httpClient.get('/lives')
    return ret
  },
  async addRestream(live_id, rtmp, streamKey) {
    let ret = await httpClient.post(`/lives/${live_id}/rtmp_endpoint`, {
      rtmp_url: `${rtmp}/${streamKey}`,
    })
    return ret
  },
  async getRestreams(live_id) {
    let ret = await httpClient.get(`/lives/${live_id}/rtmp_endpoint`)
    return ret
  },
  async getInfoHost(live_id) {
    let ret = await httpClient.get(`/lives/${live_id}/info_host`)
    return ret
  },

  async getAnalytics(live_id) {
    let ret = await httpClient.get(`/lives/${live_id}/stream_metrics`)
    return ret
  },

  async cancelLive(lives) {
    let ret = await httpClient.delete('/lives', { data: lives })
    return ret
  },
  async deleteRestreams(rtmp_id, live_id) {
    let ret = await httpClient.delete(
      `/lives/${live_id}/rtmp_endpoint?rtmp_id=${rtmp_id}`
    )
    return ret
  },
  async createLive(data, hasToken = true) {
    const session = await store().dispatch('session/refreshSession')

    let ret = await httpClient.post('/lives', {
      ...data,
      ...(hasToken
        ?  { refresh_token: session.refreshToken.token }
        : ''
      ),
    })
    return ret
  },
}
